import reduceReducers from 'reduce-reducers'

import lookupReducer from './lookup'
import filterReducer from './filter'

export default reduceReducers(
  lookupReducer,
  filterReducer,
)